import {RouteObject} from 'react-router-dom';
import {ApplicationErrorPage} from '@flexinet/ui-components';
import {AppLayout} from '../layout/AppLayout';
import {HomePage} from '../features/home/pages/HomePage';
import {SignOutPage} from '../features/home/pages/SignOutPage';
import {UsersLayout} from '../features/users/layout';
import {RequireAuth} from '../utils/RequireAuth';

// Route table consumed by App.tsx through createBrowserRouter.
//
// ⚠️ `errorElement` IS NOT OPTIONAL DECORATION. Without it, a render error
// anywhere below this route unmounts the whole tree and the user gets a blank
// white page with the reason only in the console. React Router needs a data
// router (createBrowserRouter + RouterProvider) for it to work at all, which
// is why App.tsx does not use `useRoutes`.
//
// ⚠️ Protected routes MUST be wrapped in <RequireAuth>. The skeleton used to
// define that guard and apply it to nothing, so every route was public and the
// omission was invisible. Each feature module mounts ONE <Module>Layout on a
// wildcard path; the module gates its own pages on their RBAC actions.
export const routesConfig: RouteObject[] = [
    {
        path: '/',
        element: <AppLayout/>,
        errorElement: <ApplicationErrorPage/>,
        children: [
            {index: true, element: <HomePage/>},
            // Public on purpose: signing out must work whatever the session state.
            {path: 'sign-out', element: <SignOutPage/>},
            {
                path: 'users/*',
                element: (
                    <RequireAuth>
                        <UsersLayout/>
                    </RequireAuth>
                ),
            },
        ],
    },
];
